import { useState } from "react";
import type { RuleUpdate } from "../state";
import { RulesContent } from "./RulesContent";

export function RulesUpdateModal({
  rule,
  onAcknowledge,
}: {
  rule: RuleUpdate;
  onAcknowledge: () => Promise<void>;
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const acknowledge = async () => {
    setSaving(true);
    setError(null);
    try {
      await onAcknowledge();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Could not save acknowledgement");
      setSaving(false);
    }
  };

  return (
    <div className="rules-backdrop rules-backdrop--required" role="presentation">
      <section className="rules-card rules-card--required" role="dialog" aria-modal="true" aria-labelledby="rules-update-title">
        <RulesContent update={rule} />
        {error && <div className="error rules-ack-error">{error}</div>}
        <button className="rules-ack-button" type="button" disabled={saving} onClick={() => void acknowledge()}>
          {saving ? "Saving…" : "Got it — continue"}
        </button>
      </section>
    </div>
  );
}
